function Backdrop(props){
    return(
        //backdrop is our own component, therefore it we have to built our own 'onClick event'
     <div className='backdrop' onClick={props.onCancel}></div> 
    )
}

export default Backdrop;